<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<template v-slot:header>
							<i class="icon-pencil"></i> Edit Company Info
						</template>
						<b-card-body>
							<b-form @submit.prevent="checkFormValidity()" method="post">
								<b-form-group
									label="Name"
									label-for="name"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.name" name="name" id="name" type="text" placeholder="Name"></b-form-input>
								</b-form-group>
								<b-form-group
									label="Client Panel Title"
									label-for="title"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.title" name="title" id="title" type="text" placeholder="Title"></b-form-input>
								</b-form-group>
								<b-form-group
									label="Company Group"
									label-for="companyGroup"
									:label-cols="3"
									:horizontal="true">
									<b-form-select v-model="form.companyGroupId"
																 name="companyGroup"
																 id="companyGroup"
																 :plain="true"
																 :options="companyGroupDropDownList"
																 value="Please Select">
									</b-form-select>
								</b-form-group>
								<b-form-group
									label="Administrator Email"
									label-for="email"
									:label-cols="3"
									:horizontal="true">
									<b-form-input v-model="form.email" name="email" id="email" type="text" placeholder="Admin Email" :state="$v.form.email.$dirty ? !$v.form.email.$error : null" aria-describedby="admin-email-live-feedback"></b-form-input>
									<b-form-invalid-feedback id="admin-email-live-feedback">Invalid email address.</b-form-invalid-feedback>
								</b-form-group>
								<b-form-group
									label="Is Login Enabled"
									:horizontal="true"
									:label-cols="3">
									<b-form-checkbox v-model="isLoginEnabled"
										               name="loginEnabled"
																	 id="login-enabled"
																	 switch>
									</b-form-checkbox>
								</b-form-group>


								<div class="form-actions">
									<b-button v-if="$store.getters.canWrite" type="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> Update</b-button>
									&nbsp;
									<b-button type="reset" variant="danger" @click="cancel()"><i class="fa fa-ban"></i> Cancel</b-button>
								</div>
							</b-form>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<div class="animated fadeIn">
						<genericTable v-if="adminList.length > 0" :table-data="tableData" :fields="fields" :per-page=25 hover striped bordered small
													caption="<i class='icon-list'></i> Current Administrators"></genericTable>
						<b-col cols="12" v-else>
							<b-card header-tag="header">
								<template v-slot:header>
									<i class="icon-list"></i> Current Administrators
								</template>
								<b-card-text class="text-center">This company has no administrator.</b-card-text>
							</b-card>
						</b-col>
					</div>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import toastService from "@/services/toastService";
import genericTable from "@/components/GenericTable";
import companyService from '@/services/companyService';
import {required, minValue, email} from 'vuelidate/lib/validators';
import companyGroupService from "@/services/companyGroupService";

export default {
	name: "EditCompany",
	components: {
		"genericTable" : genericTable
	},
	data: function () {
		return {
			companyId: this.$route.params.companyId,
			companyDetails: null,
			adminList: [],
			form: {
				name: null,
				title: null,
				companyGroupId: null,
				status: 1,
				email: null,
				isLoginEnabled: null,
			},
			companyGroupDropDownList: [
				{text: 'Please Select', value: null},
			],
			fields: [
				{key: 'id', label: 'ID', sortable: true, class: 'text-center'},
				{key: 'avatar', label: 'Image', class: 'text-center'},
				{key: 'name', label: 'Name', sortable: true, class: 'text-center'},
				{key: 'email', label: 'Email', class: 'text-center'},
				{key: 'status', label : 'Status', class: 'text-center'}
			],
			loading: false
		}
	},
	validations: {
		form: {
			name: {

			},
			title: {

			},
			companyGroupId: {

			},
			email: {
				validEmail: email
			}
		}
	},
	methods: {
		getCompanyDetails: function (){
			this.loading = true;
			companyService.getCompanyDetails(this.companyId, (data) => {
				this.companyDetails = data.company;
				this.isLoginEnabled = data.company.loginEnabled;
				this.adminList = data.admins;
				this.getAllCompanyGroups();
				this.loading = false;
			}, (error) => {
				toastService.showErrorToast("Could not fetch company details " + error);
				this.loading = false;
			});
		},
		getAllCompanyGroups: function () {
			companyGroupService.getAllCompanyGroups((data) => {
				this.createCompanyGroupDropDownList(data);
				this.initForm();
			}, (error) => {
				toastService.showErrorToast("Could not fetch group of companies list " + error);
			});
		},
		createCompanyGroupDropDownList: function (data) {
			data.forEach((item) => {
				let companyGroup = new Object();
				companyGroup.text = item.name;
				companyGroup.value = item.id;
				this.companyGroupDropDownList.push(companyGroup);
			});
		},
		initForm: function () {
			this.form.name = this.companyDetails.name;
			this.form.title = this.companyDetails.clientPanelTitle;
			this.form.companyGroupId = this.companyDetails.groupId;
			this.form.status = this.companyDetails.status;
		},
		resetForm: function () {
			this.form.name = null;
			this.form.title = null;
			this.form.companyGroupId = null;
			this.form.status = 1;
			this.form.email = null;
		},
		checkFormValidity: function (){
			let formHasErrors = false;

			this.$v.form.$touch();
			if (this.$v.form.$anyError) {
				formHasErrors = true;
			}

			if(formHasErrors) return;
			else this.updateCompany();
		},
		updateCompany: function (){
			const formData = {
				name: this.form.name,
				clientPanelTitle: this.form.title,
				groupId: this.form.companyGroupId,
				status: this.form.status,
				email: this.form.email,
				loginEnabled : this.isLoginEnabled
			}

			companyService.updateCompany(this.companyId, formData, (data) => {
				this.$nextTick(() => { this.$v.$reset() });
				this.resetForm();
				toastService.showSuccessToast("Company updated successfully");
				this.$router.back();
			}, (error) => {
				this.$nextTick(() => { this.$v.$reset() });
				toastService.showErrorToast("Could not update " + error);
			});
		},
		cancel: function () {
			this.resetForm();
			this.$router.back();
		}
	},
	watch: {
		$route(to, from) {
			// this.getResellerDetails();
		}
	},
	created() {
		this.getCompanyDetails();
	},
	computed: {
		tableData : function () {
			return this.adminList;
		}
	}
}
</script>

<style scoped>

</style>
